// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type GoeuroTrackingIdsContextProperties = {
  client_id: string;
  session_id: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/goeuro_tracking_ids_context/jsonschema/2-0-0';
export const goeuroTrackingIdsContextName = 'goeuro_tracking_ids_context';
export class GoeuroTrackingIdsContext extends BaseTrackingContext<GoeuroTrackingIdsContextProperties> {
  constructor(properties: GoeuroTrackingIdsContextProperties) {
    super(goeuroTrackingIdsContextName, schema, properties);
  }
}
